import { ServicesSubscriptionTypes } from './types';

export const getServiceSubscriptionStatus = (
  complementary_service_id: number,
  companyId?: number | 0,
) => ({
  types: [
    ServicesSubscriptionTypes.GET_SERVICE_SUBSCRIPTION_STATUS_REQUEST,
    ServicesSubscriptionTypes.GET_SERVICE_SUBSCRIPTION_STATUS_SUCCESS,
    ServicesSubscriptionTypes.GET_SERVICE_SUBSCRIPTION_STATUS_FAILURE,
  ],
  complementary_service_id,
  promise: (client: any) =>
    client.get(`/status_assinatura_servico`, {
      params: { complementary_service_id, companyId },
    }),
});
